import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IrGeneratorActions } from './ir-generator.actions';

@Injectable({ providedIn: 'root' })
export class IrGeneratorActionsFacade {
  private readonly _store = inject(Store);

  public addQuery(): void {
    this._store.dispatch(IrGeneratorActions.addQuery());
  }

  public generate(id: number, prompt: string): void {
    this._store.dispatch(IrGeneratorActions.generateIR({ id, prompt }));
  }

  public resetState(): void {
    this._store.dispatch(IrGeneratorActions.resetState());
  }
}
